import { render, staticRenderFns } from "./payment.view.vue?vue&type=template&id=5dfcb2f8&scoped=true"
import script from "./payment.view.vue?vue&type=script&lang=js"
export * from "./payment.view.vue?vue&type=script&lang=js"
import style0 from "./payment.view.vue?vue&type=style&index=0&id=5dfcb2f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dfcb2f8",
  null
  
)

export default component.exports